var eventTypesList = [
  { value: 'conference', text: 'Conference' },
  { value: 'summit', text: 'Summit' },
  { value: 'expo', text: 'EXPO' },
  { value: 'fairs', text: 'Fairs' },
  { value: 'meeting', text: 'Meeting' }
]
export default eventTypesList
